import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-cabinet-add",
  "use": "app-icon-cabinet-add-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-cabinet-add\"><path d=\"M4.9 5h4V4h-4zM3 5h1V4H3zM3 12h1v-1H3z\" /><path d=\"M6.1 13H2V9h4.8c.5-.8 1.1-1.5 1.9-2H2V2h7.9v4.4c.6-.2 1.3-.4 2-.4V0H0v15h6.8c-.3-.6-.6-1.3-.7-2z\" /><path d=\"M15.9 11H13V8h-2v3H8v2h3v2.9h2V13h2.9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol